import { AbstractApiService } from '@/services/abstractApiService'

class CommonService extends AbstractApiService {
  public constructor() {
    super('')
  }

  public async index(
    basePath: string,
    page: number,
    perPage: number,
    sort?: string | null,
    search?: string | null,
    filterScopes?: Map<string, string>
  ) {
    return this.http
      .get(basePath, {
        params: {
          page,
          perPage,
          sort,
          search,
          ...(filterScopes ? Object.fromEntries(filterScopes) : {})
        }
      })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }
}

export const commonService: CommonService = new CommonService()
